import { gql } from '@apollo/client';
// Fragments
import {
  OTPFields,
  UserFields,
  upcomingParticipatedStreamFields,
} from './fragments';

export const SUGGEST_USERNAMES = gql`
  query SuggestUsernames($input: SuggestUsernameInput!) {
    suggestUsernames(input: $input) {
      suggestions
    }
  }
`;

export const CHECK_USERNAME_AVAILABILITY = gql`
  query CheckUsernameAvailability($input: CheckUsernameAvailabilityInput!) {
    checkUsernameAvailability(input: $input) {
      isAvailable
    }
  }
`;

export const CHECK_EMAIL_AVAILABILITY = gql`
  query CheckEmailAvailability($input: CheckEmailAvailabilityInput!) {
    checkEmailAvailability(input: $input) {
      isAvailable
    }
  }
`;

export const ME = gql`
  query Me {
    me {
      ...UserFields
      ...upcomingParticipatedStreamFields
      ...OTPFields
    }
  }
  ${UserFields}
  ${upcomingParticipatedStreamFields}
  ${OTPFields}
`;

export const ME_PROFILE_SETUP = gql`
  query MeProfileSetup {
    me {
      id
      role
      lastName
      firstName
      slug
      email
      phoneNumber
      isOnboarded
      isEmailSet
      onboardingSteps
      status
      hasPassword
      phoneOptIn
      avatarKey
      avatarUrl
      brandDealSettings {
        id
        contactEmail
        contactPhone
        minFlatPrice
        industryCategories {
          isEnabled
          label
          value
        }
        isAcceptingFreeProducts
        isArticlesPrEnabled
        minBookMePrice
        minSocialPrice
        minSocialSharePrice
        minSponsoredLivePrice
      }
      sports {
        id
        name
      }
      hashtags {
        id
        name
      }
      influencerCategories {
        id
        name
      }
      storeDetails {
        id
        athleticLevel
        storeName
        storeTitle
        bio
        avatarURL
        socialMediaLink
        description
        coverURL
        facebookLink
        twitterLink
        instagramLink
        tiktokLink
        youtubeLink
        birthDate
        gender
        instagramFollowing
        facebookFollowing
        twitterFollowing
        tiktokFollowing
        youtubeFollowing
        careerStatus
        hometown
        hometownState
        hometownCountry
        hometownLatitude
        hometownLongitude
        city
        country
        state
        longitude
        latitude
        favoriteNumber
        bitcoinReceivingAddress
        team {
          id
          name
          sport
        }
        league {
          id
          name
          sport
        }
        college {
          id
          name
        }
      }
      sports {
        id
        name
      }
      ...OTPFields
    }
  }
  ${OTPFields}
`;

export const ME_PROFILE_COMPLETION = gql`
  query MeProfileCompletion {
    me {
      id
      role
      firstName
      storeDetails {
        id
        coverURL
        bio
      }
      brandDealSettings {
        id
      }
      profileCompletion {
        hasPersonalVideo
        hasCoverVideo
        hasBio
        hasBrandMinimums
        hasSchedule
      }
    }
  }
`;

export const CONNECTED_SOCIAL_ACCOUNTS = gql`
  query ConnectedSocialAccounts {
    connectedSocialAccounts {
      platform
      username
      providerAccountId
      followersCount
      showError
    }
  }
`;
